module.exports = __webpack_public_path__ + "1ad38d77d9c3b75a6ad17b825ceecea9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-cotton-tshirt-white.png
// module id = 839
// module chunks = 0